import solver from 'solver-utilities';
import { collection, setcollectionGridHeight } from './collection.js';
import { error } from './notification.js';
import { shopify } from './shopify.js';
import { setHeaderHeight } from './mega-menu.js';

/**
 * Set clear all fitlers display
 */
const setClearFilters = function () {
	const { search } = window.location;
	const btn = document.querySelector('[data-el="clear-filters"]');
	const paramKeys = [];

	if (!btn) return;

	if (search && search != '') {
		let active = false;
		const params = search.replace('?', '').split('&');
		params.forEach((param) => {
			const keyValue = param.split('=');
			const key = keyValue[0];
			if (key != 'availability' && key != 'sort_by') active = true;
		});

		if (active) {
			btn.classList.add('collection-filters-clear--active');
		} else {
			btn.classList.remove('collection-filters-clear--active');
		}

		return;
	}

	btn.classList.remove('collection-filters-clear--active');
};

/**
 * toggle individual filter options
 * @param { object } event - user/event generated browser object
 * @param { string } id - target fitler
 */
export const toggleFilter = function (event, id) {
	if (event) {
		event.preventDefault();
		event.currentTarget.classList.toggle('filter__toggle--active');
	}

	setcollectionGridHeight();
};

/**
 * toggle filter menu
 * @param { object } event - user/event generated browser object
 */
export const toggleFilters = function (event) {
	if (event) event.preventDefault();

	setHeaderHeight();
	document.body.classList.toggle('page--collection-filters');
};

/**
 * Trigger or opening filters on resize
 * @return { bool } true/false value
 */
export const autoOpenFilters = function () {
	const filters = document.querySelector('[data-el="collection-filters-desktop"]');
	if (window.innerWidth < 1100 || !filters) return false;

	if (document.body.className.indexOf('page--collection-filters') == -1) {
		return true;
	}

	return false;
};

/**
 * Compiles form data and query string on form change
 * @param { string } formID - ID of the for input child of
 */
const onFilterChange = async function (event, formID) {
	const form = document.querySelector(`[data-form="${formID}"]`);

	if (!form) return;

	const formData = new FormData(form);

	const price = formData.get('price');

	if (price) {
		const minmax = price.split('-');
		const min = minmax[0];
		const max = minmax[1];

		formData.append('filter.v.price.gte', min);
		formData.append('filter.v.price.lte', max);
		formData.delete('price');
	}

	const query = new URLSearchParams(formData).toString();
	const { pathname } = window.location;
	const endpoint = pathname + '?' + query;

	window.history.pushState({}, '', endpoint);

	const res = await shopify.collection.filter(endpoint);

	if (!res || (res && res.error) || (res && !res.data)) {
		error(res.error.message ? res.error.message : res.error);
		return;
	}

	await collection();
	setClearFilters();
};

/**
 * Removes filtered item from check list
 * @param { object } event - user/event generated browser object
 * @param { string } formID - ID of the for input child of
 * @param { string } inputID - ID of input to uncheck
 */
const removeFilterData = async function (event, formID, inputID) {
	const form = document.querySelector(`[data-form="${formID}"]`);
	const input = document.getElementById(inputID);

	if (!form || !input) return;

	const formData = new FormData(form);

	if (input.name == 'price') {
		formData.delete('price');
		formData.delete('filter.v.price.gte');
		formData.delete('filter.v.price.lte');
	} else {
		formData.delete(input.name);
	}

	input.checked = false;

	onFilterChange({}, formID);
};

export const filters = function () {
	if (!window.Solver || (window.Solver && !window.Solver.collection)) return;
	window.Solver.toggleFilter = toggleFilter;
	window.Solver.toggleFilters = toggleFilters;
	window.Solver.onFilterChange = onFilterChange;
	window.Solver.removeFilterData = removeFilterData;
	if (autoOpenFilters()) toggleFilters();
	setClearFilters();
};
